/* rk-lcb — comportamiento de la PDP /products/leather-crossbody-bag-kit (calco del original GemPages).
 *
 * Custom elements (todos con guarda customElements.get: el asset se carga desde varias secciones):
 *   <rk-lcb-gallery>    galería principal con scroll-snap + thumbs + flechas (desktop y mobile)
 *   <rk-lcb-swatches>   selector de color: sincroniza precio, input name="id" y galería
 *   <rk-lcb-carousel>   carrusel genérico con dots y flecha (videos "Real makers" y tiles mobile)
 *   <rk-lcb-accordion>  acordeón: el contenido SIEMPRE queda en el DOM (max-height + overflow),
 *                       nunca display:none — como el original (SEO + paridad de medición)
 *   <rk-lcb-showmore>   "Show more / Show less" de la descripción
 *   <rk-lcb-atc>        respaldo AJAX de add-to-cart (UpCart intercepta el click nativo primero)
 *
 * Sin localStorage: el tráfico de Meta llega en webviews con storage bloqueado (regla del proyecto).
 */
(function () {
  'use strict';

  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  /* ---------------------------------------------------------------- galería */
  if (!customElements.get('rk-lcb-gallery')) {
    customElements.define('rk-lcb-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track || !this.slides.length) return;

        this.index = 0;
        this.onScroll = this.sync.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        this.thumbs.forEach(function (t, i) {
          t.addEventListener('click', function () { this.goTo(i); }.bind(this));
        }.bind(this));
        if (this.prev) this.prev.addEventListener('click', function () { this.goTo(this.index - 1); }.bind(this));
        if (this.next) this.next.addEventListener('click', function () { this.goTo(this.index + 1); }.bind(this));

        this.sync();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      goTo(i) {
        var n = this.slides.length;
        /* data-loop: infinite main gallery (last -> first, first -> last) */
        i = this.hasAttribute('data-loop') && n ? ((i % n) + n) % n : Math.max(0, Math.min(i, n - 1));
        var s = this.slides[i];
        if (!s) return;
        this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.index = i;
        this.paint();
      }

      /** índice real derivado del scroll (no del click): sobrevive al swipe del usuario */
      sync() {
        var x = this.track.scrollLeft;
        var mejor = 0, dist = Infinity;
        for (var i = 0; i < this.slides.length; i++) {
          var d = Math.abs((this.slides[i].offsetLeft - this.track.offsetLeft) - x);
          if (d < dist) { dist = d; mejor = i; }
        }
        this.index = mejor;
        this.paint();
      }

      paint() {
        var i = this.index;
        this.thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          t.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
        // las flechas se esconden en los bordes (como el original)
        var lp = this.hasAttribute('data-loop');
        if (this.prev) this.prev.hidden = !lp && i <= 0;
        if (this.next) this.next.hidden = !lp && i >= this.slides.length - 1;
        // pausar los videos que quedaron fuera de vista
        this.slides.forEach(function (s, k) {
          if (k === i) return;
          var v = s.querySelector('video');
          if (v && !v.paused) v.pause();
        });
      }

      /** la usa rk-lcb-swatches al cambiar de color */
      showMedia(mediaId) {
        for (var i = 0; i < this.slides.length; i++) {
          if (this.slides[i].getAttribute('data-media-id') === String(mediaId)) { this.goTo(i); return; }
        }
      }
    });
  }

  /* --------------------------------------------------------------- swatches */
  if (!customElements.get('rk-lcb-swatches')) {
    customElements.define('rk-lcb-swatches', class extends HTMLElement {
      connectedCallback() {
        this.inputs = Array.prototype.slice.call(this.querySelectorAll('input[type="radio"]'));
        this.addEventListener('change', this.onChange.bind(this));
        // pintar el estado inicial por si el navegador restauró otra opción
        var marcado = this.inputs.filter(function (i) { return i.checked; })[0];
        if (marcado) this.aplicar(marcado, false);
      }

      onChange(ev) {
        var input = ev.target;
        if (!input || input.type !== 'radio') return;
        this.aplicar(input, true);
      }

      aplicar(input, moverGaleria) {
        var id = input.getAttribute('data-variant-id');

        // El <span data-selected-label> vive FUERA de <rk-lcb-swatches> (esta en el
        // .rk-lcb-bb__colorlabel / .rk-cga-bb__colorlabel, hermano del componente), asi que
        // buscarlo con this.querySelector devolvia null y el texto "Color: X" nunca cambiaba.
        document.querySelectorAll('[data-selected-label]').forEach(function (e) { e.textContent = input.value; });

        // El anillo de seleccionado se pintaba solo en Liquid al renderizar; el JS nunca lo movia,
        // asi que al cambiar de color quedaba marcado el swatch inicial. Los dos markups
        // (rk-lcb-bb__swatch y rk-cga-bb__swatch) envuelven el input en un <label>.
        this.inputs.forEach(function (otro) {
          var l = otro.closest('label');
          if (l) l.classList.toggle('is-active', otro === input);
          if (l) l.setAttribute('aria-checked', otro === input ? 'true' : 'false');
        });

        // todos los <input name="id"> de la página apuntan a la variante elegida
        var ids = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
        for (var i = 0; i < ids.length; i++) ids[i].value = id;

        // precios (pueden estar en varias secciones)
        var precio = input.getAttribute('data-price');
        var compara = input.getAttribute('data-compare');
        var ahorro = input.getAttribute('data-save');
        // innerHTML, no textContent: el `money_format` de esta tienda incluye
        // <span class=money> (lo usa Vitals para convertir moneda). Con textContent
        // el markup se imprimía como texto literal en la página.
        document.querySelectorAll('[data-rk-lcb-price="regular"]').forEach(function (e) { if (precio) e.innerHTML = precio; });
        document.querySelectorAll('[data-rk-lcb-price="compare"]').forEach(function (e) { if (compara) e.innerHTML = compara; });
        document.querySelectorAll('[data-rk-lcb-price="save"]').forEach(function (e) { if (ahorro) e.innerHTML = ahorro; });

        // disponibilidad
        var libre = input.getAttribute('data-available') === 'true';
        document.querySelectorAll('[data-rk-lcb-atc]').forEach(function (b) {
          b.disabled = !libre;
          var t = b.querySelector('[data-atc-label]');
          if (t) t.textContent = libre ? (b.getAttribute('data-label') || t.textContent) : (b.getAttribute('data-oos-label') || 'Out of stock');
        });

        if (moverGaleria) {
          var media = input.getAttribute('data-media-id');
          if (media) {
            document.querySelectorAll('rk-lcb-gallery').forEach(function (g) {
              if (g.showMedia) g.showMedia(media);
            });
            // shared rk-gallery: its thumbs carry data-media-id; clicking one moves the main image
            var th = document.querySelector('[data-rk-gal-thumb][data-media-id="' + media + '"]');
            if (th) th.click();
          }
        }
      }
    });
  }

  /* -------------------------------------------------------------- carrusel */
  if (!customElements.get('rk-lcb-carousel')) {
    customElements.define('rk-lcb-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-dot]'));
        this.next = this.querySelector('[data-next]');
        this.prev = this.querySelector('[data-prev]');
        if (!this.track || !this.slides.length) return;

        // ---------------------------------------------------------------------------
        // Dots: el original NO usa el mismo criterio en los dos breakpoints (medido sobre
        // /products/leather-crossbody-bag-kit con 6 videos):
        //   desktop → 2 dots  = un dot por PÁGINA        → ceil(6 / 3 visibles)
        //   mobile  → 5 dots  = un dot por PASO de 1     → 6 − 2 visibles + 1
        // Por eso el modo se elige por breakpoint (data-dots / data-dots-mobile).
        // ---------------------------------------------------------------------------
        this.dotsHost = this.querySelector('[data-dots-host]');
        this.construirDots();

        this.index = 0;
        this.onScroll = this.sync.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.dots.forEach(function (d, i) { d.addEventListener('click', function () { this.goTo(i * (this.porPagina || 1)); }.bind(this)); }.bind(this));
        if (this.next) this.next.addEventListener('click', function () { this.goTo(this.index + 1); }.bind(this));
        if (this.prev) this.prev.addEventListener('click', function () { this.goTo(this.index - 1); }.bind(this));

        if (this.hasAttribute('data-drag')) this.bindDrag();

        // al cambiar el ancho cambian los slides visibles (y con eso la cantidad de dots)
        this.onResize = function () { this.construirDots(); this.sync(); }.bind(this);
        window.addEventListener('resize', this.onResize, { passive: true });

        this.sync();
      }

      /** mouse drag (touch already scrolls natively): drag the strip, release snaps to the nearest slide */
      bindDrag() {
        var track = this.track, self = this, x0 = null, left0 = 0, moved = false;
        track.style.cursor = 'grab';
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (e.target.closest('video') && e.offsetY > e.target.clientHeight - 60) return; // leave the native controls bar alone
          x0 = e.clientX; left0 = track.scrollLeft; moved = false;
        });
        window.addEventListener('pointermove', function (e) {
          if (x0 === null) return;
          var dx = e.clientX - x0;
          if (!moved && Math.abs(dx) < 5) return;
          if (!moved) { moved = true; track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto'; track.style.cursor = 'grabbing'; }
          track.scrollLeft = left0 - dx;
        });
        function fin() {
          if (x0 === null) return;
          x0 = null;
          track.style.cursor = 'grab';
          if (!moved) return;
          var x = track.scrollLeft, mejor = 0, dist = Infinity;
          for (var i = 0; i < self.slides.length; i++) {
            var d = Math.abs((self.slides[i].offsetLeft - track.offsetLeft) - x);
            if (d < dist) { dist = d; mejor = i; }
          }
          track.style.scrollSnapType = '';
          track.style.scrollBehavior = '';
          self.goTo(mejor);
          setTimeout(function () { moved = false; }, 0);
        }
        window.addEventListener('pointerup', fin);
        window.addEventListener('pointercancel', fin);
        // a drag must not toggle play/pause on the video it started on
        track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
        track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        if (this.onResize) window.removeEventListener('resize', this.onResize);
      }

      /** slides que entran en el viewport del track (el gap del último no cuenta) */
      visibles() {
        var a = this.slides[0], b = this.slides[1];
        var anchoSlide = a ? a.getBoundingClientRect().width : 0;
        var paso = (a && b) ? (b.offsetLeft - a.offsetLeft) : anchoSlide;
        var gap = Math.max(0, paso - anchoSlide);
        if (!paso) return 1;
        return Math.max(1, Math.round((this.track.clientWidth + gap) / paso));
      }

      construirDots() {
        var host = this.dotsHost;
        if (!host) return;                       // los dots fijos del markup se respetan
        var modo = window.matchMedia('(max-width: 749px)').matches
          ? (this.getAttribute('data-dots-mobile') || this.getAttribute('data-dots'))
          : this.getAttribute('data-dots');
        if (!modo) return;
        var vis = this.visibles();
        var n = modo === 'pasos'
          ? Math.max(1, this.slides.length - vis + 1)
          : Math.max(1, Math.ceil(this.slides.length / vis));
        this.modoDots = modo;
        this.porPagina = modo === 'pasos' ? 1 : vis;
        if (this.dots && this.dots.length === n && host.children.length === n) return;
        var clase = (this.getAttribute('data-dot-class') || 'rk-lcb-vc__dot');
        host.innerHTML = '';
        for (var k = 0; k < n; k++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = clase + (k === 0 ? ' is-active' : '');
          b.setAttribute('data-dot', '');
          b.setAttribute('aria-label', String(k + 1));
          host.appendChild(b);
        }
        this.dots = Array.prototype.slice.call(host.querySelectorAll('[data-dot]'));
        this.dots.forEach(function (d, i) {
          d.addEventListener('click', function () { this.goTo(i * (this.porPagina || 1)); }.bind(this));
        }.bind(this));
      }

      goTo(i) {
        i = Math.max(0, Math.min(i, this.slides.length - 1));
        var s = this.slides[i];
        if (!s) return;
        this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.index = i;
        this.paint();
      }

      sync() {
        var x = this.track.scrollLeft, mejor = 0, dist = Infinity;
        for (var i = 0; i < this.slides.length; i++) {
          var d = Math.abs((this.slides[i].offsetLeft - this.track.offsetLeft) - x);
          if (d < dist) { dist = d; mejor = i; }
        }
        this.index = mejor;
        this.paint();
      }

      paint() {
        var activo = this.porPagina ? Math.floor(this.index / this.porPagina) : this.index;
        this.dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === activo);
          d.setAttribute('aria-current', k === activo ? 'true' : 'false');
        });
        var fin = this.index >= this.slides.length - 1;
        if (this.next) this.next.hidden = fin;
        if (this.prev) this.prev.hidden = this.index <= 0;
      }
    });
  }

  /* ------------------------------------------------------------- acordeón */
  if (!customElements.get('rk-lcb-accordion')) {
    customElements.define('rk-lcb-accordion', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-acc-item]'));
        this.unicoAbierto = this.getAttribute('data-single') === 'true';
        this.items.forEach(function (item) {
          var btn = item.querySelector('[data-acc-head]');
          if (!btn) return;
          btn.addEventListener('click', function () { this.toggle(item); }.bind(this));
        }.bind(this));
      }

      toggle(item) {
        var abierto = item.getAttribute('data-open') === 'true';
        if (this.unicoAbierto && !abierto) {
          this.items.forEach(function (o) { if (o !== item) this.cerrar(o); }.bind(this));
        }
        if (abierto) this.cerrar(item); else this.abrir(item);
      }

      abrir(item) {
        var panel = item.querySelector('[data-acc-panel]');
        var head = item.querySelector('[data-acc-head]');
        item.setAttribute('data-open', 'true');
        if (head) head.setAttribute('aria-expanded', 'true');
        if (!panel) return;
        panel.style.maxHeight = panel.scrollHeight + 'px';
        var fin = function () { panel.style.maxHeight = 'none'; panel.removeEventListener('transitionend', fin); };
        panel.addEventListener('transitionend', fin);
      }

      cerrar(item) {
        var panel = item.querySelector('[data-acc-panel]');
        var head = item.querySelector('[data-acc-head]');
        item.setAttribute('data-open', 'false');
        if (head) head.setAttribute('aria-expanded', 'false');
        if (!panel) return;
        if (panel.style.maxHeight === 'none') panel.style.maxHeight = panel.scrollHeight + 'px';
        raf(function () { raf(function () { panel.style.maxHeight = '0px'; }); });
      }
    });
  }

  /* ------------------------------------------------------------- show more */
  if (!customElements.get('rk-lcb-showmore')) {
    customElements.define('rk-lcb-showmore', class extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-sm-body]');
        this.btn = this.querySelector('[data-sm-btn]');
        this.label = this.querySelector('[data-sm-label]');
        if (!this.body || !this.btn) return;
        this.abierto = false;
        this.btn.addEventListener('click', function () {
          this.abierto = !this.abierto;
          this.body.setAttribute('data-open', this.abierto ? 'true' : 'false');
          this.btn.setAttribute('aria-expanded', this.abierto ? 'true' : 'false');
          if (this.label) this.label.textContent = this.abierto
            ? (this.getAttribute('data-less') || 'Show less')
            : (this.getAttribute('data-more') || 'Show more');
        }.bind(this));
      }
    });
  }

  /* ----------------------------------------------- fechas de entrega estimada */
  if (!customElements.get('rk-lcb-dates')) {
    customElements.define('rk-lcb-dates', class extends HTMLElement {
      connectedCallback() {
        // Calco del <gp-estimate-date> de GemPages: formato "%b %d" (Sep 18) en la zona
        // horaria del visitante; los rangos se imprimen "Sep 21 - Sep 24".
        var meses = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var fmt = function (dias) {
          var d = new Date();
          d.setDate(d.getDate() + dias);
          return meses[d.getMonth()] + ' ' + String(d.getDate()).padStart(2, '0');
        };
        this.querySelectorAll('[data-offset]').forEach(function (el) {
          var off = (el.getAttribute('data-offset') || '0').split('-');
          el.textContent = off.length === 1
            ? fmt(Number(off[0]))
            : fmt(Number(off[0])) + ' - ' + fmt(Number(off[1]));
        });
      }
    });
  }

  /* -------------------------------------------------------------- add to cart */
  if (!customElements.get('rk-lcb-atc')) {
    customElements.define('rk-lcb-atc', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.btn = this.querySelector('[data-rk-lcb-atc]');
        if (!this.form || !this.btn) return;
        // UpCart intercepta el click del botón y hace SU add + abre el drawer (comportamiento
        // nativo del theme). Este submit es el respaldo si ese interceptor no está.
        this.form.addEventListener('submit', this.onSubmit.bind(this));

        // selector de cantidad (solo en la instancia del buybox)
        var campo = this.querySelector('input[name="quantity"]');
        this.querySelectorAll('[data-qty]').forEach(function (b) {
          b.addEventListener('click', function () {
            if (!campo) return;
            var n = Number(campo.value || 1) + Number(b.getAttribute('data-qty'));
            campo.value = Math.max(1, n);
            campo.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }

      onSubmit(ev) {
        ev.preventDefault();
        var btn = this.btn;
        if (btn.disabled || window.__rkLcbAdding) return; /* shared flag: hero + sticky are separate instances */
        window.__rkLcbAdding = true;
        btn.disabled = true;
        btn.setAttribute('data-loading', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(this.form.querySelector('input[name="id"]').value),
              quantity: Number((this.form.querySelector('input[name="quantity"]') || {}).value || 1)
            }]
          })
        })
          .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('upcart:refresh'));
            document.dispatchEvent(new CustomEvent('upcart:open'));
            if (!window.RkCart) { if (window.__rkCartEarly && window.__rkCartEarly.hold) window.__rkCartEarly.hold(); else window.location.href = '/cart'; }
          })
          .catch(function () { if (!window.RkCart) window.location.href = '/cart'; })
          .then(function () { window.__rkLcbAdding = false; btn.disabled = false; btn.removeAttribute('data-loading'); });
      }
    });
  }
})();
